import React, { useEffect } from 'react';
import { Container } from 'reactstrap';
import styles from './PlcUpgradeAbilities.module.css'
import { Upload } from '../Upload/Upload';
import urls from '../../Services/Urls.js';
import { Redirect, withRouter } from 'react-router-dom';

const PlcUpgradeAbilities = (props) => {

    useEffect(() => {
        const token = localStorage.getItem("access_token");

        if (token) {
            const base64Url = token.split('.')[1]
            const base64 = base64Url.replace('-', '+').replace('_', '/')
            const { exp } = JSON.parse(window.atob(base64))
            if (Date.now() >= exp * 1000) {
                localStorage.removeItem("access_token");
                props.refreshNavMenu();
                props.history.push('/');
            }
        }
    }, []);

    if (!localStorage.getItem("access_token"))
        return <Redirect to='/login' />

    return (
        <Container className={styles.Activate}>
            <h1>Add PLCs to the Upgraded / Extended abilities list</h1>
            <p>Select a CSV file that contains the Serial number and the MAC of the PLCs</p>

            <ul>
                <li><strong>Upload</strong>. The file is structured as either 2 columns (comma separated) of serial, MAC, or a single colum with serial only</li>
            </ul>

            <Upload sendToUrl={urls.postExtendPLCAbilitiesFile} noResposeFile={true} />
        </Container>
    );
}

export default withRouter(PlcUpgradeAbilities);